/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum CcbSwitchName {
    ENABLE_AUDIO_AND_CC_SUBTITLE_PERSISTANCE_REMOVE_IN_KST_12164,
    ENABLE_DEBUG_SCREEN,
    ENABLE_DEVELOPER_SANDBOX,
    ENABLE_INCLUDE_ADULT,
    ENABLE_INFO_CARD_REMOVE_IN_KST_12193,
    ENABLE_MOBI_DRM_REMOVE_IN_KST_7121,
    ENABLE_MY_RENTALS_REMOVE_IN_KST_12205,
    ENABLE_PLAY_NEXT_REMOVE_IN_KST_12934,
    ENABLE_SUBSCRIBED_CHANNELS,
    ENABLE_TRANSPORT_STREAM_FE_REMOVE_IN_KST_14322,
    ENABLE_V2_CHANNELS_REMOVE_IN_KST_12928,
    ENABLE_VOD_BROWSE_MAIN_SCREEN_REMOVE_IN_KST_12159,
    ENABLE_VOD_BROWSE_PROGRAM_SCREEN_REMOVE_IN_KST_12208,
    ENABLE_VOD_GALLERY_SCREEN_KST_12423,
    ENABLE_VOD_JUMP_CHANNEL_REMOVE_IN_KST_12189,
    ENABLE_VOD_PLAYBACK_REMOVE_IN_KST_12166,
    ENABLE_VOD_SLT_REMOVE_IN_KST_12207,
    ENABLE_VOD_PLAY_ACTION_REMOVE_IN_KST_12288,
    ENABLE_VOD_PREVIEW_REMOVE_IN_KST_14762,
    ENABLE_CAST_SLT_REMOVE_IN_KST_12418,
    ENABLE_MAY_ALSO_LIKE_SLT_REMOVE_IN_KST_12418,
    ENABLE_ONDEMAND_EPISODE_REMOVE_IN_KST_12206,
    ENABLE_SIMPLIFIED_SIGN_IN_REMOVE_IN_KST_12173,
    ENABLE_VOD_DEVICE_REGISTRATION_REMOVE_IN_KST_14933,
    ENABLE_V3_QUICK_MENU_SHORTCUT_REMOVE_IN_KST_16510,
}
